<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'ventas-operarios'}">{{$t("ventasOperarios")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("ventasDeProductosDe")}} {{nameOperario}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="listTPV">{{$t("TPV")}}</label>
                                <div class="row">
                                    <div class="col-8">
                                        <el-select class="select-default"
                                                   size="large"
                                                   v-model="idTpv"
                                                   filterable
                                                   @change="changeTPV()"
                                                   :placeholder="$t('seleccionaNegocio')">
                                            <el-option v-for="tpv in listTpv"
                                                       class="select-primary"
                                                       :value="tpv.id"
                                                       :label="tpv.nameShow"
                                                       :key="tpv.nameShow">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div class="col-4">
                                        <button class="btn btn-primary"
                                                @click="openModal()"><i
                                                class="fa fa-filter"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        format="dd-MM-yyyy"
                                        :title="$t('fechaInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        :title="$t('fechaFin')"
                                        format="dd-MM-yyyy"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="dateto"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <label>&nbsp;</label>
                            <div class="form-group">
                                <button class="btn btn-primary" @click="getSalesProducts()">
                                    <img src="static/img/sync.gif" alt="" v-if="loading" width="15">
                                    {{$t("consultar")}}
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="col-md-8">
                <template v-if="list.length>0">
                    <div class="row justify-content-between div-export">

                        <div class="col-md-2 col-xs-12 text-right">
                            <el-dropdown>
                                <el-button type="primary" size="small">
                                    <i class="fa fa-file"></i>
                                    {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <a :href="urlExportPDF">
                                        <el-dropdown-item class="text-danger">
                                            <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                    <a :href="urlExportExcel">
                                        <el-dropdown-item class="text-success">
                                            <strong>
                                                <i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}
                                            </strong>
                                        </el-dropdown-item>
                                    </a>
                                </el-dropdown-menu>
                            </el-dropdown>

                        </div>
                        
                        <div class="col-md-auto col-xs-auto">
                            <el-checkbox v-model="ignoreNegativeValues">
                                {{$t("ignorarRecuentosNegativos")}}
                            </el-checkbox>
                        </div>
                        
                    </div>

                    <div class="table-responsive">

                        <table class="table table-bordered table-striped text-nowrap">
                            <thead class="thead-dark">
                                <tr style="cursor: pointer;">
                                    <th v-if="ordenacionProductos===0" @click="sortedArrayNameASC('name')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("producto")}}
                                    </th>
                                    <th v-else @click="sortedArrayNameDESC('name')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t("producto")}}
                                    </th>
                                    <th v-if="ordenarCantidad===0" @click="sortedArrayCantidadASC('cantidad')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("cantidad")}}
                                    </th>
                                    <th v-else @click="sortedArrayCantidadDESC('cantidad')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t("cantidad")}}
                                    </th>
                                    <th v-if="ordenarImporte===0" @click="sortedArrayImporteASC('importe')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("importe")}}
                                    </th>
                                    <th v-else @click="sortedArrayImporteDESC('importe')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t("importe")}}
                                    </th>
                                    <th v-if="ordenarPrecioMed===0" @click="sortedArrayPrecioMedASC('importe/cantidad')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("precioMed")}}
                                    </th>
                                    <th v-else @click="sortedArrayPrecioMedDESC('importe/cantidad')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t("precioMed")}}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="obj in filteredList">
                                    <td>{{obj.name}}</td>
                                    <td><span v-if="obj.pedirPeso" class="text-primary">{{obj.cantidad}} Kg.</span><span
                                            v-else>{{obj.cantidad}}</span></td>
                                    <td class="text-right">{{obj.importe | currency}}</td>
                                    <td class="text-right">{{(obj.importe /obj.cantidad) | currency}}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr class="table-success">
                                    <td><strong>{{$t("total")}}</strong></td>
                                    <td class="text-right"><strong>{{getTotalUDs}}</strong></td>
                                    <td class="text-right"><strong>{{getTotalPrecio | currency}}</strong></td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </template>
                <template v-else>
                    <div class="alert alert-danger" role="alert">
                        {{$t("noHay")}} <strong>{{$t('ventasDeProductos')}}</strong> {{$t("rangoDeFechas")}}
                    </div>
                </template>
            </div>

            <div class="col-md-4 " v-show="this.list.length > 0">
                <div class="card">
                    <button v v-if="chartIn===0" @click="chartIn=1, initChart()" class="btn btn-primary col-md-12">
                        {{$t("porUnidad")}}
                    </button>
                    <button v-else @click="chartIn=0,initChart()" class="btn btn-primary col-md-12">
                        {{$t("porImporte")}}
                    </button>

                    <div class="chart-container col-md-12" style="height:300px; width: 100%">
                        <canvas id="chart"></canvas>
                    </div>
                </div>
            </div>

            <modal name="filtradoTPV" :adaptive=true :scrollable=true height="auto" :clickToClose=true>
                <div>
                    <div class="modal-header">
                        <h4 style="margin: 0px">{{$t("filtrarPorTPV")}}</h4>
                    </div>
                    <div class="modal-body">

                        <el-checkbox-group :min="1" v-model="idsTPV" size="medium">
                            <el-checkbox v-for="tpv in listCheckBoxTpv" :label=tpv.id :key="tpv.id" border>
                                {{tpv.nameShow}}
                            </el-checkbox>
                        </el-checkbox-group>

                    </div>
                    <div class="modal-footer">
                        <div align="right" class="col-12">
                            <button class="btn btn-primary" @click="getSalesProducts()"><i class="fa fa-search"></i>
                                {{$t("invitaciones")}}
                            </button>
                        </div>
                    </div>
                </div>
            </modal>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import Chart from 'chart.js';
    import {
        DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button,
        Checkbox,
        CheckboxGroup
    } from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'
    //import CabeceraInformes from "../../../../components/CabeceraInformes/CabeceraInformes";
    import bus from '../../../../bus'

    export default {
        created() {
            this.loading = true;
            this.$store.dispatch("setNameRoute", this.$i18n.t("ventasDeProductos"));
            this.getTpv();

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;
            }

            bus.$on('get-ventas', (item) => {
                this.getVentas();
            });

            bus.$on('get-business', (idBusiness) => {
                this.idBusiness = idBusiness;
                this.idsTPV = [];
                this.idTpv = 0;

                this.getTpv();
            });

            bus.$on('get-tpv', (idTpv) => {
                this.idTpv = idTpv;

                this.changeTPV();
            });

            bus.$on('get-date', (dates) => {
                this.value4 = dates;

                this.getSalesProducts();
            });

            bus.$on('get-open-modal', (item) => {
                this.openModal();
            });
        },
        components: {
            //CabeceraInformes,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup
        },
        data() {
            return {
                loading: false,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),

                idBusiness: this.$route.params.idBusiness,
                value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                list: [],
                mode: 0,
                $Chart: null,
                objectChart: null,
                contador: 0,
                chartIn: 0,
                listTpv: [],
                idTpv: 0,
                dateRangeOptions1: {
                    firstDayOfWeek: 1
                },

                listCheckBoxTpv: [],
                idsTPV: [],

                ordenacionProductos: 0,
                ordenarCantidad: 0,
                ordenarImporte: 0,
                ordenarPrecioMed: 0,

                idWorker: this.$route.params.idWorker,
                nameOperario:this.$route.params.workerName,
                
                ignoreNegativeValues: false
            }
        },
        computed: {
            filteredList() {
                if (!this.ignoreNegativeValues) {
                    return this.list;
                }
                return this.list.filter(function(item) {
                    const precioMedio = item.importe / item.cantidad;
                    return item.importe >= 0 && precioMedio >= 0;
                });
            },
            
            urlExportPDF() {
                var tpv = "";

                this.idsTPV.forEach(function (d) {
                    tpv += d + ',';
                });

                return this.$store.getters.apiUrl+"/workers/exportSalesProductsByWorker/PDF?idBusiness=" + this.idBusiness + "&idTpv=" + tpv + "&idWorker=" + this.idWorker + "&nameWorker=" + this.nameOperario + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },

            urlExportExcel() {
                var tpv = "";

                this.idsTPV.forEach(function (d) {
                    tpv += d + ',';
                });

                return this.$store.getters.apiUrl+"/workers/exportSalesProductsByWorker/Excel?idBusiness=" + this.idBusiness + "&idTpv=" + tpv + "&idWorker=" + this.idWorker + "&nameWorker=" + this.nameOperario + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },

            getTotalPrecio() {
                let total = 0;

                this.filteredList.forEach(function (d) {
                    total += d.importe;
                });

                return total;
            },
            getTotalUDs() {
                let total = 0;

                this.filteredList.forEach(function (d) {
                    total += d.cantidad;
                });

                return total;
            }
        },
        methods: {
            sortedArrayNameASC: function () {
                this.ordenacionProductos = 1;

                function compare(a, b) {
                    if (a.name.toUpperCase() < b.name.toUpperCase())
                        return -1;
                    if (a.name.toUpperCase() > b.name.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayNameDESC: function () {
                this.ordenacionProductos = 0;

                function compare(a, b) {

                    if (a.name.toUpperCase() > b.name.toUpperCase())
                        return -1;
                    if (a.name.toUpperCase() < b.name.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayCantidadASC: function () {
                this.ordenarCantidad = 1;

                function compare(a, b) {
                    if (a.cantidad < b.cantidad)
                        return -1;
                    if (a.cantidad > b.cantidad)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayCantidadDESC: function () {
                this.ordenarCantidad = 0;

                function compare(a, b) {

                    if (a.cantidad > b.cantidad)
                        return -1;
                    if (a.cantidad < b.cantidad)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteASC: function () {
                this.ordenarImporte = 1;

                function compare(a, b) {
                    if (a.importe < b.importe)
                        return -1;
                    if (a.importe > b.importe)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteDESC: function () {
                this.ordenarImporte = 0;

                function compare(a, b) {

                    if (a.importe > b.importe)
                        return -1;
                    if (a.importe < b.importe)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayPrecioMedASC: function () {
                this.ordenarPrecioMed = 1;

                function compare(a, b) {
                    if (a.importe / a.cantidad < b.importe / b.cantidad)
                        return -1;
                    if (a.importe / a.cantidad > b.importe / b.cantidad)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayPrecioMedDESC: function () {
                this.ordenarPrecioMed = 0;

                function compare(a, b) {

                    if (a.importe / a.cantidad > b.importe / b.cantidad)
                        return -1;
                    if (a.importe / a.cantidad < b.importe / b.cantidad)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },

            changeTPV() {
                if (this.idTpv === 0) {
                    this.idsTPV = [];

                    for (let i = 0; i < this.listCheckBoxTpv.length; i++) {
                        this.idsTPV.push(this.listCheckBoxTpv[i].id)
                    }
                } else {
                    this.idsTPV = []
                    this.idsTPV.push(this.idTpv)
                }

                this.getSalesProducts();
            },

            openModal() {
                this.$modal.show('filtradoTPV');
            },

            getTpv() {
                this.listTpv = [];

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                    .then(function (response) {
                        if (response.data.response) {
                            for (let i = 0; i < response.data.result.length; i++) {
                                vm.idsTPV.push(response.data.result[i].id)
                            }

                            vm.listCheckBoxTpv = response.data.result;

                            let printer = {
                                nameShow: vm.$t('todos'),
                                id: 0
                            };
                            vm.listTpv.push(printer);

                            for (let i = 0; i < response.data.result.length; i++) {
                                let printername = {
                                    nameShow: response.data.result[i].nameShow,
                                    id: response.data.result[i].id
                                };

                                vm.listTpv.push(printername)
                            }

                            vm.getSalesProducts();
                        }

                        vm.loading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            getSalesProducts() {
                this.$modal.hide('filtradoTPV');

                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {
                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    } else {
                        this.loading = true;

                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);

                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                idWorker: this.idWorker,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                idTpv: this.idsTPV,
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.axios.get(this.$store.getters.apiUrl + "workers/getSalesProductsByWorker", config)
                            .then(function (response) {
                                if (response.data.response) {
                                    vm.list = response.data.result;

                                    vm.initChart();

                                } else {
                                    swal({
                                        title: vm.$t('accesoDenegado'),
                                        text: vm.$t('noTienesPermisoParaVisualizarEsteInforme'),
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });
                                }

                                vm.loading = false;
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }
            },

            initChart() {
                if (this.chartIn === 0) {
                    var labels = this.filteredList.map(function (x) {
                        return x.name;
                    });

                    var data = this.filteredList.map(function (x) {
                        return x.cantidad;
                    });

                } else {
                    var labels = this.filteredList.map(function (x) {
                        return x.name;
                    });

                    var data = this.filteredList.map(function (x) {
                        return x.importe;
                    });
                }

                var randomColor = require('randomcolor');
                var colors = randomColor({luminosity: 'dark', count: labels.length, format: 'rgb'});

                let backgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)";
                });

                let borderColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)";
                });

                let hoverBackgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)";
                });

                if (this.contador == 0) {
                    if (this.filteredList.length > 0) {
                        this.objectChart = new Chart("chart", {
                            type: 'pie',
                            data: {
                                labels: labels,
                                datasets: [{
                                    data: data,
                                    backgroundColor: backgroundColors,
                                    borderColor: borderColors,
                                    hoverBackgroundColor: hoverBackgroundColors,
                                    borderWidth: 1
                                }]
                            },
                            options: {
                                legend: {
                                    display: false,
                                    position: 'bottom',
                                },
                                maintainAspectRatio: false,
                            }
                        });

                        this.contador++;
                    }
                } else {
                    this.objectChart.destroy();

                    this.objectChart = new Chart('chart', {
                        type: 'pie',
                        data: {
                            labels: labels,
                            datasets: [{
                                data: data,
                                backgroundColor: backgroundColors,
                                borderColor: borderColors,
                                hoverBackgroundColor: hoverBackgroundColors,
                                borderWidth: 1
                            }]
                        },
                        options: {
                            legend: {
                                display: false,
                                position: 'bottom',
                            },
                            maintainAspectRatio: false,
                        }
                    });
                }
            }
        }
    }
</script>
<style scoped>
    a li {
        color: #111;
    }
    .card {
        padding: 20px;
    }
    .div-export {
        margin-bottom: 10px;
    }
    body {
        background: #1D1F20;
        padding: 16px;
    }
    .chart-container {
        position: relative;
        margin: auto;
        height: 80vh;
        width: 80vw;
    }
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Operarios/VentasProductosPorOperarios.vue